import React, {useState} from "react";
import { Button } from "@mui/material";
import Feedback from "./Feedback";
import { BRAND_NAME, COPYRIGHT_YEAR } from "../branding";

const Footer = ({ pastLogin = true }) => {
  const [showFeedback, setShowFeedback] = useState(false);
  const loggedIn = localStorage.getItem("sc_name") && pastLogin ? true : false;

  return(
    <>
    <footer className="sco-footer">
      <div className="sco-footer-inner">
        <span className="sco-footer-meta">
          {loggedIn ? "Logged in as" : `© ${COPYRIGHT_YEAR} ${BRAND_NAME}`}
        </span>
        <strong className="sco-footer-name">
          {loggedIn ? localStorage.getItem("sc_name") : "Service Center Owner"}
        </strong>
        <Button
          className="sco-footer-feedback"
          variant="outlined"
          size="small"
          onClick={() => setShowFeedback(true)}
        >
          Feedback
        </Button>
      </div>
    </footer>

    {showFeedback && <Feedback onClose={() => setShowFeedback(false)} />}
    </>
  );
};

export default Footer;
